import { TableState } from "../model/TableState";

export interface ITableService {
  persistedState?: TableState;
  saveTableState(newState: TableState): void;
  clearTableState(): void;
}

export const TableService = Symbol.for("TableService");
